// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  margin-top: 50px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 74rem;
  font-size: 12px;
  text-align: center;
  margin-right: auto;
  margin-left: auto;
}
@media screen and (min-width: 834px) {
  .footer {
    flex-direction: row;
  }
}
@media screen and (min-width: 991px) {
  .footer {
    padding-right: 2rem;
    padding-left: 2rem;
  }
}
@media screen and (min-width: 1440px) {
  .footer {
    font-size: 16px;
  }
}
.footer a {
  text-decoration: none;
}
.footer .logo {
  cursor: pointer;
}
@media screen and (max-width: 834px) {
  .footer .logo {
    margin: auto;
  }
}
.footer .items {
  opacity: 0.7;
  flex-grow: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.footer .items a {
  color: white;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 1rem;
  margin-left: 1rem;
  cursor: pointer;
}
.footer .items a.active {
  color: #03E287;
}
.footer .items .dropdown-container {
  margin-top: auto;
  margin-bottom: auto;
  cursor: pointer;
  position: relative;
}
.footer .items .dropdown-container .title {
  cursor: pointer;
  display: flex;
}
.footer .items .dropdown-container .title div {
  margin-right: 0.5rem;
}
.footer .items .dropdown-container .title img {
  width: 20px;
  margin-top: auto;
  margin-bottom: auto;
}
.footer .items .dropdown-container .dropdown {
  position: absolute;
  width: 200px;
  top: 30;
  left: 0;
  padding: 1rem;
  background: rgba(1, 20, 29, 0.19);
  backdrop-filter: blur(9.5px);
  border-radius: 17px;
  border: 1px solid #01141D;
}
.footer .items .dropdown-container .dropdown.d-none {
  display: none;
}
.footer .cta-button {
  display: flex;
  border-radius: 20px;
  padding-right: 1rem;
  padding-left: 1rem;
  border: 2px solid #03E287;
  cursor: pointer;
}
@media screen and (max-width: 834px) {
  .footer .cta-button {
    display: none;
  }
}
.footer .cta-button img {
  width: 1rem;
  height: 1rem;
  margin-top: auto;
  margin-bottom: auto;
}
.footer .cta-button span {
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 0.25rem;
  color: #03E287;
}

.text-green {
  color: #03E287;
}

.copyright {
  margin-top: auto;
  margin-bottom: auto;
}`, "",{"version":3,"sources":["webpack://./src/styles/footer.scss"],"names":[],"mappings":"AACA;EACE,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAAF;AACE;EAXF;IAYI,mBAAA;EAEF;AACF;AADE;EAdF;IAeI,mBAAA;IACA,kBAAA;EAIF;AACF;AAHE;EAlBF;IAmBI,eAAA;EAMF;AACF;AALE;EACE,qBAAA;AAOJ;AALE;EACE,eAAA;AAOJ;AANI;EAFF;IAGI,YAAA;EASJ;AACF;AAPE;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AASJ;AARI;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAUN;AATM;EACE,cAAA;AAWR;AAPI;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AASN;AARM;EACE,eAAA;EACA,aAAA;AAUR;AATQ;EACE,oBAAA;AAWV;AATQ;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;AAWV;AARM;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,OAAA;EACA,aAAA;EACA,iCAAA;EACA,4BAAA;EACA,mBAAA;EACA,yBAAA;AAUR;AATQ;EACE,aAAA;AAWV;AALE;EAIE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AAIJ;AAZI;EADF;IAEI,aAAA;EAeJ;AACF;AARI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AAUN;AARI;EACE,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;AAUN;;AANA;EACE,cAAA;AASF;;AAPA;EACE,gBAAA;EACA,mBAAA;AAUF","sourcesContent":["\r\n.footer{\r\n  margin-top: 50px;\r\n  padding-bottom: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  max-width: 74rem;\r\n  font-size: 12px;\r\n  text-align: center;\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n  @media screen and (min-width: 834px){\r\n    flex-direction: row;\r\n  }\r\n  @media screen and (min-width: 991px){\r\n    padding-right: 2rem;\r\n    padding-left: 2rem;\r\n  }\r\n  @media screen and (min-width: 1440px){\r\n    font-size: 16px;\r\n  }\r\n  a{\r\n    text-decoration: none;\r\n  }\r\n  .logo{\r\n    cursor: pointer;\r\n    @media screen and (max-width: 834px){\r\n      margin:auto;\r\n    }\r\n  }\r\n  .items{\r\n    opacity: 0.7;\r\n    flex-grow: 1;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: center; \r\n    margin-top: 1rem;\r\n    margin-bottom: 1rem;   \r\n    a{\r\n      color: white;\r\n      margin-top: auto;\r\n      margin-bottom: auto;\r\n      margin-right: 1rem;\r\n      margin-left: 1rem;\r\n      cursor: pointer;\r\n      &.active{\r\n        color: #03E287;\r\n      }\r\n    }\r\n    \r\n    .dropdown-container{\r\n      margin-top: auto;\r\n      margin-bottom: auto;\r\n      cursor: pointer;\r\n      position: relative;\r\n      .title{\r\n        cursor: pointer;\r\n        display: flex;\r\n        div{\r\n          margin-right: 0.5rem;\r\n        }\r\n        img{\r\n          width: 20px;\r\n          margin-top: auto;\r\n          margin-bottom: auto;\r\n        }\r\n      }\r\n      .dropdown{\r\n        position: absolute;\r\n        width: 200px;\r\n        top:30;\r\n        left: 0;\r\n        padding: 1rem;\r\n        background: rgba(1, 20, 29, 0.19);\r\n        backdrop-filter: blur(9.5px);\r\n        border-radius: 17px;\r\n        border: 1px solid #01141D;\r\n        &.d-none{\r\n          display: none;\r\n        }\r\n      }\r\n\r\n    }\r\n  }\r\n  .cta-button{\r\n    @media screen and (max-width: 834px){\r\n      display:none;\r\n    }\r\n    display: flex;\r\n    border-radius: 20px;\r\n    padding-right: 1rem;\r\n    padding-left: 1rem;\r\n    border: 2px solid #03E287;\r\n    cursor: pointer;\r\n    img{\r\n      width: 1rem;\r\n      height: 1rem;\r\n      margin-top: auto;\r\n      margin-bottom:auto;\r\n    }\r\n    span{\r\n      margin-top: auto;\r\n      margin-bottom: auto;\r\n      margin-left: 0.25rem;\r\n      color:#03E287;\r\n    }\r\n  }\r\n}\r\n.text-green{\r\n  color:#03E287;\r\n}\r\n.copyright{\r\n  margin-top: auto;\r\n  margin-bottom: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
